import React, { Component } from 'react';
import { connect } from 'react-redux';

import { endVideoSettingsFlow } from 'actions/editor';

import CTAForm from '../cta-form';
import ThumbnailWidget from '../thumbnail-widget';
import VideoSettings from '../video-settings';

import { headerHeight } from 'components/layout/header';

import './styles.less';

const EDITOR_MODE_CLASS = 'editor-mode-enabled';

class EditorWidget extends Component {
  render() {
    const {
      ctaFlow,
      thumbnailFlow,
      privacySettingsFlow,
      customAccessFlow,
      videoSettingsFlow,
      video,
    } = this.props;

    const className =
      (ctaFlow ? ' cta' : '') +
      (customAccessFlow ? ' custom-access' : '') +
      (privacySettingsFlow ? ' privacy' : '') +
      (thumbnailFlow ? ' thumbnail' : '') +
      (videoSettingsFlow ? ' video-settings' : '');

    const itemArray = [
      ctaFlow && <CTAForm key="cta-form" />,
      thumbnailFlow && <ThumbnailWidget key="thumbnail-widget" />,
      videoSettingsFlow && (
        <VideoSettings
          key="video-settings"
          video={video}
          onSaveClick={this.props.endVideoSettingsFlow}
          onCancelClick={this.props.endVideoSettingsFlow}
        />
      ),
    ].filter(Boolean);

    return (
      <div
        className={`edit-video${className}`}
        ref={ref => (this.container = ref)}
      >
        {itemArray.map(item => (
          <div key={item.key}>{item}</div>
        ))}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.editorMode != prevProps.editorMode) {
      const rootElement = document.documentElement;

      rootElement.className = rootElement.className.replace(
        EDITOR_MODE_CLASS,
        ''
      );

      if (this.props.editorMode) {
        rootElement.className += ` ${EDITOR_MODE_CLASS}`;

        if (this.container) {
          // we scroll to the top of the container, minus headerHeight to account for nav
          window.scroll(
            0,
            this.container.getBoundingClientRect().y - headerHeight
          );
        }
      }
    }
  }
}

const mapStateToProps = state => {
  const {
    editor,
    share_video: {
      cta_enabled: hasCta,
      video: { thumbnails = {} },
    },
    video_player: { in_upload_mode: inUploadMode },
  } = state;
  const {
    cta_flow: ctaFlow,
    thumbnail_flow: thumbnailFlow,
    privacy_settings_flow: privacySettingsFlow,
    video_settings_flow: videoSettingsFlow,
    custom_access_flow: customAccessFlow,
    editorMode = ctaFlow ||
      thumbnailFlow ||
      privacySettingsFlow ||
      videoSettingsFlow ||
      customAccessFlow,
  } = editor;

  return {
    ctaFlow,
    thumbnailFlow,
    privacySettingsFlow,
    customAccessFlow,
    videoSettingsFlow,
    editorMode,
    hasCta,
    inUploadMode,
    hasCustomThumbnail: thumbnails.full,
  };
};

const mapDispatchToProps = dispatch => ({
  endVideoSettingsFlow: () => dispatch(endVideoSettingsFlow()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorWidget);
